import { ERD, VmessCategoryActions } from "@dots-crm/contracts/client";
import { api } from "api";
import { QueryArgsNew } from "api/api.type";
import {
  VMESS_CATEGORY_ENDPOINTS_URLS,
  VMESS_CATEGORY_TAGS,
} from "./api-vmess-category.constant";

export const {
  useCreateVmessCategoryMutation,
  useReadManyVmessCategoriesQuery,
  useReadAvailableVmessCategoriesQuery,
  useUpdateVmessCategoryMutation,
  useDeleteVmessCategoryMutation,
} = api.injectEndpoints({
  endpoints: (builder) => ({
    createVmessCategory: builder.mutation<
      ERD<VmessCategoryActions["create"]>,
      QueryArgsNew<VmessCategoryActions["create"]>
    >({
      query: ({ payload }) => ({
        url: VMESS_CATEGORY_ENDPOINTS_URLS.create,
        method: "post",
        payload,
      }),
      invalidatesTags: [VMESS_CATEGORY_TAGS.vmessCategory],
    }),
    readManyVmessCategories: builder.query<
      ERD<VmessCategoryActions["readMany"]>,
      QueryArgsNew<VmessCategoryActions["readMany"]>
    >({
      query: ({ query }) => ({
        url: VMESS_CATEGORY_ENDPOINTS_URLS.readMany,
        method: "get",
        query,
      }),
      providesTags: [VMESS_CATEGORY_TAGS.vmessCategory],
    }),
    readAvailableVmessCategories: builder.query<
      ERD<VmessCategoryActions["readAvailable"]>,
      QueryArgsNew<VmessCategoryActions["readAvailable"]>
    >({
      query: () => ({
        url: VMESS_CATEGORY_ENDPOINTS_URLS.readAvailable,
        method: "get",
      }),
      providesTags: [VMESS_CATEGORY_TAGS.vmessCategory],
    }),
    updateVmessCategory: builder.mutation<
      void,
      QueryArgsNew<VmessCategoryActions["update"]>
    >({
      query: ({ payload, params }) => ({
        url: VMESS_CATEGORY_ENDPOINTS_URLS.update(params),
        method: "put",
        payload,
      }),
      invalidatesTags: [VMESS_CATEGORY_TAGS.vmessCategory],
    }),
    deleteVmessCategory: builder.mutation<
      void,
      QueryArgsNew<VmessCategoryActions["delete"]>
    >({
      query: ({ params }) => ({
        url: VMESS_CATEGORY_ENDPOINTS_URLS.delete(params),
        method: "delete",
      }),
      invalidatesTags: [VMESS_CATEGORY_TAGS.vmessCategory],
    }),
  }),
});
